import { SchoolContent } from "../../components/configuration";

export default function School() {
  return (
    <>
      <SchoolContent />
    </>
  );
}
